import {
    Directive,
    ElementRef,
    HostListener,
    EventEmitter,
    OnInit,
    Input,
    Inject,
} from "@angular/core";
import { PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";

@Directive({
    selector: "[draggableContainer]",
})
export class DraggableContainerDirective implements OnInit {
    private enabled: boolean = false;

    public ulPosition: number = 0;
    private startPosition: number = 0;
    private mouseDownPosition: number = 0;

    @Input() public moveRightEvent: EventEmitter<any> = new EventEmitter();
    @Input() public allowClickEvent: EventEmitter<boolean> = new EventEmitter();

    // comm
    @Input() public tellCurrentUlPosition: EventEmitter<number> =
        new EventEmitter();
    @Input() public forceUlPositionEvent: EventEmitter<number> =
        new EventEmitter();
    @Input() public triggerSetupEvent: EventEmitter<any> = new EventEmitter();
    @Input() public ulCurrentPosition: number;
    @Input() public ulMaxPosition: number;

    public isBrowser: boolean = isPlatformBrowser(this.platformId);

    constructor(
        @Inject(PLATFORM_ID) private platformId,
        public element: ElementRef
    ) {}

    ngOnInit() {
        if (this.isBrowser) {
            this.moveRightEvent.subscribe((px) => {
                let range = px + this.ulPosition;
                if (range > 0) {
                    range = 0;
                }
                this.element.nativeElement.style.transform =
                    "translateX(" + range + "px)";
                this.ulPosition = range;
                this.tellCurrentUlPosition.emit(range);
            });

            this.forceUlPositionEvent.subscribe((px: number) => {
                this.element.nativeElement.style.transform =
                    "translateX(" + px + "px)";
                this.ulPosition = px;
                this.tellCurrentUlPosition.emit(px);
            });

            this.element.nativeElement.style.transform =
                "translateX(" + this.ulCurrentPosition + "px)";
            this.ulPosition = this.ulCurrentPosition;
        }
    }

    @HostListener("mousedown", ["$event"]) onMouseDown(event) {
        this.enabled = true;
        let clientX = Math.round(event.clientX);
        this.touchStart(clientX);
        this.allowClickEvent.emit(true);
        this.mouseDownPosition = this.ulPosition;
    }

    @HostListener("mousemove", ["$event"]) onMouseMove(event) {
        if (this.enabled) {
            let clientX = Math.round(event.clientX);
            this.touchMove(clientX);
            this.allowClickEvent.emit(false);
        }
    }

    @HostListener("mouseup", ["$event"]) onMouseUp(event) {
        let clientX = Math.round(event.clientX);
        this.touchEnd(clientX);
        this.enabled = false;

        // allow to click if position didnt change much
        if (Math.abs(this.mouseDownPosition - this.ulPosition) <= 5) {
            this.allowClickEvent.emit(true);
        }
    }

    @HostListener("mouseleave", ["$event"]) onMouseLeave(event) {
        this.enabled = false;
    }

    @HostListener("touchstart", ["$event"]) onTouchStart(event) {
        let clientX = Math.round(event.touches[0].clientX);
        this.touchStart(clientX);
        this.allowClickEvent.emit(true);
    }

    @HostListener("touchmove", ["$event"]) onTouchMove(event) {
        let clientX = Math.round(event.touches[0].clientX);
        this.touchMove(clientX);
        this.allowClickEvent.emit(false);
    }

    @HostListener("touchend", ["$event"]) onTouchEnd(event) {
        let clientX = Math.round(event.changedTouches[0].clientX);
        this.touchEnd(clientX);
    }

    private touchStart(px: number) {
        this.startPosition = px;
    }

    private touchMove(px: number) {
        let range = px - this.startPosition;
        let translateX = range + this.ulPosition;
        if (translateX > 0) {
            translateX = 0;
        }
        if (translateX < this.ulMaxPosition) {
            translateX = this.ulMaxPosition;
            this.ulPosition = this.ulMaxPosition;
        }

        this.element.nativeElement.style.transform =
            "translateX(" + translateX + "px)";
        this.tellCurrentUlPosition.emit(translateX);
    }

    private touchEnd(px: number) {
        let range = px - this.startPosition;
        let ulPosition = this.ulPosition + range;
        if (ulPosition > 0) {
            ulPosition = 0;
        }
        this.ulPosition = ulPosition;
    }
}
